import {
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableObservableCompletionListener,
    DataTableObservableDataSource,
    DataTableObservableErrorListener,
    DataTableObservableRefresher,
    TableAction
} from '@cas-hub/acabim-common-client';
import {SubCategoryTableData} from '../work-order.model';

export class WorkOrderCategoriesDataSource<T extends SubCategoryTableData> extends DataTableObservableDataSource<T> {

    columnData: DataTableColumnData[] = [];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];

    onDataExpanded(value: SubCategoryTableData): void {
    }

    constructor(
        private readonly type: string,
        readonly dataRefresher: DataTableObservableRefresher<T>,
        readonly observableErrorListener?: DataTableObservableErrorListener,
        readonly observableCompleteListener?: DataTableObservableCompletionListener,
        readonly actionListener?: (action: TableAction) => void
    ) {
        super(() => this.dataRefresher(),
            undefined, undefined);
            this.columnData = [
                {displayName: 'Name', objectPropertyName: 'name'},
                {displayName: 'CBI class', objectPropertyName: 'cbi_class_display', colWidth: '12rem'},
                {displayName: 'OmniClass', objectPropertyName: 'omniclass', colWidth: '12rem'},
                {displayName: 'Last modified', objectPropertyName: 'last_modified_display', colWidth: '8rem'},
                {displayName: 'Status', objectPropertyName: 'status_display', colWidth: '5rem', textAlign: 'center'}
            ];
        this.config = {
            tableHeading: this.type.toUpperCase(),
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: 'No work sub-categories found',
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: false,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: false,
            hasActions: false
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }

}
